export default __webpack_public_path__ + "static/media/network.ae4ce623.png";